/* eslint-disable max-len */
const PluginLojaIntegrada = require('./PluginLojaIntegrada');
const PluginMagento = require('./PluginMagento');
const PluginNuvemShop = require('./PluginNuvemShop');
const PluginPrestashop = require('./PluginPrestashop');
const PluginShopify = require('./PluginShopify');
const PluginVTEX = require('./PluginVTEX');
const PluginWix = require('./PluginWix');
const PluginWoocommerce = require('./PluginWoocommerce');

module.exports = { PluginLojaIntegrada, PluginMagento, PluginNuvemShop, PluginPrestashop, PluginShopify, PluginVTEX, PluginWix, PluginWoocommerce };
